export default __webpack_public_path__ + "static/media/logo_transparant.6d56b796.png";